import { LodgingAddressExact, LodgingData, HomesReservation } from "redmond";

const getMapUrl = (lat: number, lon: number, name: string, address: string): string => {
  const ua = navigator.userAgent;

  if (/iPhone|iPad|iPod/.test(ua)) {
    // Apple Maps native app
    return `maps://?ll=${encodeURIComponent(`${lat},${lon}&q=${name}`)}`;
  }

  if (/Android/.test(ua)) {
    // Android native maps app
    return `geo:${encodeURIComponent(`${lat},${lon}?q=${lat},${lon}(${name})`)}`;
  }

  return `https://www.google.com/maps?q=${encodeURIComponent(`${name}, ${address}`)}`
}

export const getMapUrlForLodging = (lodging: LodgingData): string => {
  const { lat, lon } = lodging.location.coordinates
  const { name } = lodging
  const address = (lodging.address as LodgingAddressExact)?.line1

  return getMapUrl(lat, lon, name, address)
}

export const getMapUrlForHomeReservation = (homeReservation: HomesReservation): string | null => {
  const lat = homeReservation.listing.location?.coordinates.lat;
  const lon = homeReservation.listing.location?.coordinates.lon;
  if (!lat || !lon) {
    return null;
  }

  const { name } = homeReservation.listing;
  const { address } = homeReservation.listing;

  return getMapUrl(lat, lon, name, address)
}
